export const HowFeeling = {
  Good: 'GOOD',
  Norm: 'NORM',
  Difficult: 'DIFFICULT',
  Terrible: 'TERRIBLE'
}
